import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-tableau-planing',
  templateUrl: './tableau-planing.component.html',
  styleUrls: ['./tableau-planing.component.css']
})
export class TableauPlaningComponent implements OnInit {

  constructor() {
  }

  ngOnInit(): void {
  }

}
